
export function parseDate(dateString) {
    if (!dateString)
        return null;  // Invalid input string

    var dateRegex = /^\d{4}-\d{2}-\d{2}$/;
    if(!dateString.match(dateRegex))
        return null;  // Invalid format

    var date = new Date(dateString);
    var dateNumber = date.getTime();
    if(!dateNumber && dateNumber !== 0)
        return null; // NaN value, Invalid date

    return date.toISOString().slice(0,10) === dateString ? date : null;
}
